import { type User, getUser as getUserData } from '@/shared/api/experience';

export const useUserStore = defineStore('hc-user-store', () => {
  const user = ref<Nullable<User>>(null);
  const isModerator = ref<boolean>(false);

  const getUser = async () => {
    const { data: userData } = await getUserData();
    user.value = userData?.user || null;
    isModerator.value = userData?.user?.is_moderator || false;

    return user.value;
  };

  return {
    user,
    isModerator,
    getUser,
  };
});
